export const popupUtil = {
  create(Popup, props = {}, target?: HTMLElement) {
    const popup = new Popup({
      target: target || document.body,
      props,
      intro: true,
    });
    const handleUrlChange = createHandleUrlChange(popup);
    popup.$on('close', handleUrlChange);
    return popup;
  },
  wait(Popup, propsCreator) {
    return new Promise((resolve) => {
      const popup = new Popup({
        target: document.body,
        props: propsCreator(resolve),
        intro: true,
      });
      const handleUrlChange = createHandleUrlChange(popup);
      popup.$on('close', handleUrlChange);
    });
  },
};

function createHandleUrlChange(popup) {
  const handleUrlChange = () => {
    window.removeEventListener('popstate', handleUrlChange, false);
    popup && popup.$destroy();
  };
  window.addEventListener('popstate', handleUrlChange);

  return handleUrlChange;
}
